export default "__VITE_ASSET__iFFaeHXw__"